import React, { useState } from 'react'
import LastMenu from './LastMenu';
import Mainmenu from './MainMenu';
import you from '../../assets/images/boy.png'

import bot from '../../assets/images/happy.png'; 

const Other = () => {

    const [showMenu, setShowMenu] = useState(true);
        const [showFrame1, setShowFrame1] = useState(false);
        const [showFrame2, setShowFrame2] = useState(false);
        const [showFrame3, setShowFrame3] = useState(false);
        const [showFrame4, setShowFrame4] = useState(false);
        const [showFrame5, setShowFrame5] = useState(false);
        const [showFrame6, setShowFrame6] = useState(false);
    
        
          const [time, setTime] = useState(new Date());

  return (
    <div>

        <div className="frame1 animated-frame">
        What do you want to know more about?
        </div>
        {showMenu && 
        <div className='menu-btns animated-frame'>
            <button className="menu-btn" 
                    onClick={() =>{
                        setTime(new Date());
                        setShowMenu(false);
                        setShowFrame1(true);
                        setShowFrame2(false);
                        setShowFrame3(false);
                        setShowFrame4(false);
                        setShowFrame5(false);
                        setShowFrame6(false);
                    }}
                >Alumni Status</button>

            <button className="menu-btn" 
                    onClick={() =>{
                        setTime(new Date());
                        setShowMenu(false);
                        setShowFrame1(false);
                        setShowFrame2(true);
                        setShowFrame3(false);
                        setShowFrame4(false);
                        setShowFrame5(false);
                        setShowFrame6(false);
                    }}
                >EMBA</button>
            <button className="menu-btn" 
                    onClick={() =>{
                        setTime(new Date());
                        setShowMenu(false);
                        setShowFrame1(false);
                        setShowFrame2(false);
                        setShowFrame3(true);
                        setShowFrame4(false);
                        setShowFrame5(false);
                        setShowFrame6(false);
                    }}
                >Employment</button>
            <button className="menu-btn" 
                    onClick={() =>{
                        setTime(new Date());
                        setShowMenu(false);
                        setShowFrame1(false);
                        setShowFrame2(false);
                        setShowFrame3(false);
                        setShowFrame4(true);
                        setShowFrame5(false);
                        setShowFrame6(false);
                    }}
                >Guest Speakers</button>
            <button className="menu-btn" 
                    onClick={() =>{
                        setTime(new Date());
                        setShowMenu(false);
                        setShowFrame1(false);
                        setShowFrame2(false);
                        setShowFrame3(false);
                        setShowFrame4(false);
                        setShowFrame5(true);
                        setShowFrame6(false);
                    }}
                >HBS Online</button>
            <button className="menu-btn" 
                    onClick={() =>{
                        setTime(new Date());
                        setShowMenu(false);
                        setShowFrame1(false);
                        setShowFrame2(false);
                        setShowFrame3(false);
                        setShowFrame4(false);
                        setShowFrame5(false);
                        setShowFrame6(true);
                    }}
                >Restart the chat</button>
        </div>
        }


        {showFrame1 && (
            <>
            <div className="you-time">
            <img src={you} alt="boy" className="boy" />
                You {time?.toLocaleTimeString()}
            </div>
            <div className="you-message">
                <div className="frame2">Alumni Status</div>
            </div>
            <div className='chatbot'>
                <img src={bot} alt="bot" className="bot" />
                <div className='chatbot-time'>{time.toLocaleTimeString()}</div>
                </div>
            <div className="frame1 animated-frame">
            Visit our Alumni Network page for a list of programs that grant HBS alumni status.
            </div>
            <LastMenu id={6}  />

            </>
        )}

        {showFrame2 && (
            <>
            <div className="you-time">
            <img src={you} alt="boy" className="boy" />
                You {time?.toLocaleTimeString()}
            </div>
            <div className="you-message">
                <div className="frame2">EMBA</div>
            </div>
            <div className='chatbot'>
                <img src={bot} alt="bot" className="bot" />
                <div className='chatbot-time'>{time.toLocaleTimeString()}</div>
                </div>
            <div className="frame1 animated-frame">
            The HBS MBA program requires full-time attendance for two years. We do not offer an EMBA or a part-time MBA program. </div>
            <LastMenu id={6}  />
            </>
        )}

        {showFrame3 && (
            <>
            <div className="you-time">
            <img src={you} alt="boy" className="boy" />
                You {time?.toLocaleTimeString()}
            </div>
            <div className="you-message">
                <div className="frame2">Employment</div>
            </div>
            <div className='chatbot'>
                <img src={bot} alt="bot" className="bot" />
                <div className='chatbot-time'>{time.toLocaleTimeString()}</div>
                </div>
            <div className="frame1 animated-frame">
            Thank you for your interest in working at Harvard. You can search Harvard’s employment opportunities here.
            </div>
            <LastMenu id={6}  />
            </>
        )}

        {showFrame4 && (
            <>
            <div className="you-time">
            <img src={you} alt="boy" className="boy" />
                You {time?.toLocaleTimeString()}
            </div>
            <div className="you-message">
                <div className="frame2">Guest Speakers</div>
            </div>
            <div className='chatbot'>
                <img src={bot} alt="bot" className="bot" />
                <div className='chatbot-time'>{time.toLocaleTimeString()}</div>
                </div>
            <div className="frame1 animated-frame">
            Guest speakers contribute to our programs at the invitation of our faculty. We do not consider unsolicited guest speaker requests.
            </div>
            <LastMenu id={6} />
            </>
        )}

        {showFrame5 && (
            <>
            <div className="you-time">
            <img src={you} alt="boy" className="boy" />
                You {time?.toLocaleTimeString()}
            </div>
            <div className="you-message">
                <div className="frame2">HBS Online</div>
            </div>
            <div className='chatbot'>
                <img src={bot} alt="bot" className="bot" />
                <div className='chatbot-time'>{time.toLocaleTimeString()}</div>
                </div>
            <div className="frame1 animated-frame">
            You can learn more about HBS Online programs here or contact them through the Support Portal.
           </div>
            <LastMenu id={6} />
            </>
        )}

        {showFrame6 && (
                <>
                <div className="you-time">
                <img src={you} alt="boy" className="boy" />
                You {time?.toLocaleTimeString()}
                </div>
                <div className="you-message">
                <div className="frame2">Restart the chat</div>
                </div>

                <div className='chatbot'>
                <img src={bot} alt="bot" className="bot" />
                <div className='chatbot-time'>{time.toLocaleTimeString()}</div>
                </div>
                    <Mainmenu />
                </>
            )}


    </div>
  )
}

export default Other